"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../shared/controllers/BaseController");
var moment = require("moment");
var DlgSetPromoCodeExpirationParamCtl = /** @class */ (function (_super) {
    __extends(DlgSetPromoCodeExpirationParamCtl, _super);
    function DlgSetPromoCodeExpirationParamCtl() {
        return _super.call(this, true) || this;
    }
    DlgSetPromoCodeExpirationParamCtl.prototype.ResetData = function () {
        var dYear = moment().year();
        var dMonth = moment().month() + 1;
        var dDay = moment().add(2, 'd').date();
        //alert(`${dYear} -> ${dMonth} -> ${dDay}`)
        this.DATA = {
            onYes: null,
            title: "",
            visible: false,
            is_expire: false,
            year: dYear,
            month: dMonth,
            day: dDay
        };
    };
    DlgSetPromoCodeExpirationParamCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgSetPromoCodeExpirationParamCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgSetPromoCodeExpirationParamCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgSetPromoCodeExpirationParamCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgSetPromoCodeExpirationParamCtl.prototype.SetOnYesClick = function (callback) {
        this.DATA.onYes = callback;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgSetPromoCodeExpirationParamCtl.prototype, "onYesClick", {
        get: function () {
            return this.DATA.onYes;
        },
        enumerable: true,
        configurable: true
    });
    DlgSetPromoCodeExpirationParamCtl.prototype.SetTitle = function (title) {
        this.DATA.title = title;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgSetPromoCodeExpirationParamCtl.prototype, "Title", {
        get: function () {
            return this.DATA.title;
        },
        enumerable: true,
        configurable: true
    });
    DlgSetPromoCodeExpirationParamCtl.prototype.SetYear = function (Year) {
        this.DATA.year = Year;
        this.Update();
        return this;
    };
    DlgSetPromoCodeExpirationParamCtl.prototype.SetMonth = function (Month) {
        this.DATA.month = Month;
        this.Update();
        return this;
    };
    DlgSetPromoCodeExpirationParamCtl.prototype.SetDay = function (Day) {
        this.DATA.day = Day;
        this.Update();
        return this;
    };
    DlgSetPromoCodeExpirationParamCtl.prototype.SetIsExpire = function (IsExpire) {
        this.DATA.is_expire = IsExpire;
        this.Update();
        return this;
    };
    return DlgSetPromoCodeExpirationParamCtl;
}(BaseController_1.BaseController));
exports.DlgSetPromoCodeExpirationParamCtl = DlgSetPromoCodeExpirationParamCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ctl/DlgSetPromoCodeExpirationParamCtl.ts
// module id = 912
// module chunks = 0